<template>
  <div>
    <v-card v-show="!showCompanyProfile" class="card-shadow border-radius-xl">
      <div
        class="card-header-padding d-flex justify-space-between align-center"
      >
        <h5 class="font-weight-bold text-h5 text-typo mb-0">公司管理</h5>
        <v-btn-toggle v-if="false" v-model="viewMode" mandatory dense>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn value="list" large v-bind="attrs" v-on="on">
                <v-icon>mdi-format-list-bulleted</v-icon>
                <span class="ml-1">列表</span>
              </v-btn>
            </template>
            <span>列表顯示</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn value="grid" large v-bind="attrs" v-on="on">
                <v-icon>mdi-grid</v-icon>
                <span class="ml-1">格狀</span>
              </v-btn>
            </template>
            <span>格狀顯示</span>
          </v-tooltip>
        </v-btn-toggle>
      </div>

      <v-card-text class="px-0 py-0">
        <v-data-table
          v-if="viewMode === 'list'"
          :headers="headers"
          :items="companies"
          :loading="loading"
          :server-items-length="totalItems"
          class="table"
          hide-default-footer
          @page-count="pageCount = $event"
          disable-pagination
          :items-per-page="itemsPerPage"
          mobile-breakpoint="0"
          :item-class="rowClass"
          @click:row="(item) => viewProfile(item)"
        >
          <template v-slot:top>
            <v-toolbar flat min-height="80" height="auto" class="py-4 py-md-0">
              <v-row align="center" class="w-100 mx-0">
                <v-col cols="12" md="4">
                  <v-text-field
                    hide-details
                    class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                    dense
                    flat
                    filled
                    solo
                    height="43"
                    v-model="company_name"
                    placeholder="搜尋公司名稱"
                    clearable
                    @input="onSearchInput"
                  >
                    <template slot="prepend-inner">
                      <v-icon color="#adb5bd" size=".875rem"
                        >fas fa-search</v-icon
                      >
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3" class="d-flex align-center">
                  <v-select
                    v-model="statusFilter"
                    :items="statusOptions"
                    item-text="text"
                    item-value="value"
                    hide-details
                    dense
                    outlined
                    class="mt-0"
                    label="狀態"
                    @change="onStatusChange"
                  ></v-select>
                </v-col>
                <v-spacer class="d-none d-md-block"></v-spacer>
                <v-col cols="12" md="auto" class="d-flex justify-end">
                  <v-dialog v-model="dialog" max-width="900px" scrollable>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        elevation="0"
                        :ripple="false"
                        height="43"
                        class="
                          font-weight-bold
                          text-capitalize
                          btn-primary
                          bg-gradient-primary
                          py-3
                          px-6
                        "
                      >
                        <v-icon size="18">mdi-plus</v-icon>
                        新增</v-btn
                      >
                    </template>
                    <v-card class="card-shadow border-radius-xl">
                      <div class="card-header-padding card-border-bottom">
                        <span class="font-weight-bold text-h5 text-typo mb-0">{{
                          formTitle
                        }}</span>
                      </div>
                      <v-card-text class="card-padding px-0">
                        <v-tabs
                          v-model="activeTab"
                          background-color="transparent"
                          class="text-left px-4"
                        >
                          <v-tabs-slider></v-tabs-slider>
                          <v-tab :ripple="false" href="#tab-1">
                            <span class="ms-1">基本資料</span>
                          </v-tab>
                          <v-tab :ripple="false" href="#tab-2">
                            <span class="ms-1">聯絡資訊</span>
                          </v-tab>
                          <v-tab :ripple="false" href="#tab-3">
                            <span class="ms-1">其他設定</span>
                          </v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="activeTab" class="mt-4">
                          <v-tab-item value="tab-1">
                            <company-basic-info-widget
                              :company-data="editedItem"
                              :is-create-mode="true"
                              @save="
                                (payload, done) =>
                                  onWidgetSave('basic', payload, done)
                              "
                            ></company-basic-info-widget>
                          </v-tab-item>
                          <v-tab-item value="tab-2">
                            <company-contact-info-widget
                              :company-data="editedItem"
                              :is-create-mode="true"
                              @save="
                                (payload, done) =>
                                  onWidgetSave('contact', payload, done)
                              "
                            ></company-contact-info-widget>
                          </v-tab-item>
                          <v-tab-item value="tab-3">
                            <company-financial-info-widget
                              :company-data="editedItem"
                              :is-create-mode="true"
                              @save="
                                (payload, done) =>
                                  onWidgetSave('financial', payload, done)
                              "
                            ></company-financial-info-widget>
                          </v-tab-item>
                        </v-tabs-items>
                      </v-card-text>

                      <v-card-actions class="card-padding d-flex justify-end">
                        <v-btn
                          @click="close"
                          elevation="0"
                          :ripple="false"
                          height="43"
                          class="
                            font-weight-bold
                            text-capitalize
                            btn-ls btn-secondary
                            bg-gradient-light
                            py-3
                            px-6
                          "
                          >取消</v-btn
                        >

                        <v-btn
                          @click="save"
                          elevation="0"
                          :ripple="false"
                          height="43"
                          :loading="saving"
                          class="
                            font-weight-bold
                            text-capitalize
                            btn-ls btn-primary
                            bg-gradient-primary
                            py-3
                            px-6
                          "
                          >儲存</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
                <!-- refresh button -->
                <v-col cols="12" md="auto" class="d-flex justify-end px-0">
                  <v-btn
                    @click="refreshCompanies()"
                    elevation="0"
                    :ripple="false"
                    height="43"
                    class="
                      font-weight-bold
                      text-capitalize
                      btn-default
                      bg-gradient-default
                      py-3
                      px-6
                    "
                  >
                    <v-icon size="18">mdi-refresh</v-icon>
                    刷新</v-btn
                  >
                </v-col>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              indeterminate
              color="primary"
              height="3"
            ></v-progress-linear>
          </template>

          <template v-slot:loading>
            <tr>
              <td :colspan="headers.length" class="text-center py-6">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="32"
                  width="3"
                  class="mr-2"
                />
                載入中...
              </td>
            </tr>
          </template>
          <!-- is_active -->
          <template v-slot:item.is_active="{ item }">
            <div class="d-flex align-center">
              <span
                class="rounded-circle"
                :class="{
                  'bg-success': item.is_active,
                  'bg-danger': !item.is_active,
                }"
                style="width: 12px; height: 12px"
              ></span>
            </div>
          </template>

          <template v-slot:item.company_name="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">
                {{ item.company_name }}
              </span>
            </div>
          </template>

          <template v-slot:item.taxid="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">
                {{ item.taxid }}
              </span>
            </div>
          </template>

          <template v-slot:item.capital_str="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">
                NT$ {{ Number(item.capital_str).toLocaleString() }}
              </span>
            </div>
          </template>

          <template v-slot:item.employee_num="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">
                {{ item.employee_num }}
              </span>
            </div>
          </template>

          <template v-slot:item.owner_name="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">
                {{ item.owner_name }}
              </span>
            </div>
          </template>

          <template v-slot:item.website="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">
                <a :href="item.website" target="_blank" class="text-primary">
                  {{ item.website }}
                </a>
              </span>
            </div>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              @click.stop="viewProfile(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-sm"
              color="#344767"
              title="查看公司"
            >
              <v-icon size="18">ni-building</v-icon>
            </v-btn>
            <v-btn
              v-if="canNotifyCompanies"
              @click.stop="notifyCompanyEmployees(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-md"
              color="#17c1e8"
              title="通知公司所有員工"
            >
              <v-icon size="16">mdi-bell</v-icon>
            </v-btn>
            <v-btn
              v-if="item.id !== 1 && item.is_active === false"
              @click.stop="reactivateItem(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-md"
              color="#67748e"
            >
              <v-icon size="12">ni-button-play text-lg</v-icon>
            </v-btn>
            <v-btn
              v-if="item.id !== companies[0].id && item.is_active === true"
              @click.stop="deleteItem(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-md"
              color="#67748e"
            >
              <v-icon size="12">ni-button-pause text-lg</v-icon>
            </v-btn>
          </template>
        </v-data-table>

        <!-- Grid View -->
        <div v-if="viewMode === 'grid'" class="grid-view-container pa-4">
          <!-- Toolbar for Grid View -->
          <v-row class="mb-4">
            <v-col cols="12" md="4">
              <v-text-field
                hide-details
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
                height="43"
                v-model="company_name"
                placeholder="搜尋公司名稱"
                clearable
                @input="onSearchInput"
              >
                <template slot="prepend-inner">
                  <v-icon color="#adb5bd" size=".875rem">fas fa-search</v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3" class="d-flex align-center">
              <v-select
                v-model="statusFilter"
                :items="statusOptions"
                item-text="text"
                item-value="value"
                hide-details
                dense
                outlined
                class="mt-0"
                label="狀態"
                @change="onStatusChange"
              ></v-select>
            </v-col>
            <v-spacer class="d-none d-md-block"></v-spacer>
            <v-col cols="12" md="auto" class="d-flex justify-end">
              <v-btn
                @click="dialog = true"
                elevation="0"
                :ripple="false"
                height="43"
                class="
                  font-weight-bold
                  text-capitalize
                  btn-primary
                  bg-gradient-primary
                  py-3
                  px-6
                "
              >
                <v-icon size="18">mdi-plus</v-icon>
                新增</v-btn
              >
            </v-col>
          </v-row>

          <v-row>
            <v-col
              v-for="(company, index) in companies"
              :key="index"
              cols="12"
              sm="6"
              md="4"
              class="mb-4"
            >
              <v-card
                class="company-card h-100 card-shadow border-radius-xl"
                @click="viewProfile(company)"
                style="cursor: pointer"
              >
                <v-card-text class="pa-4">
                  <div class="d-flex justify-space-between align-center mb-2">
                    <h3 class="font-weight-bold mb-0">
                      {{ company.company_name }}
                    </h3>
                    <v-chip
                      x-small
                      label
                      :color="company.is_active ? 'light-green' : 'red'"
                      text-color="white"
                      class="px-2"
                    >
                      {{ company.is_active ? "啟用中" : "已停用" }}
                    </v-chip>
                  </div>

                  <div class="mt-4">
                    <div class="d-flex align-center mb-2">
                      <v-icon size="18" color="grey" class="mr-2"
                        >mdi-identifier</v-icon
                      >
                      <span class="text-body-2">統編: {{ company.taxid }}</span>
                    </div>
                    <div class="d-flex align-center mb-2">
                      <v-icon size="18" color="grey" class="mr-2"
                        >mdi-web</v-icon
                      >
                      <a
                        :href="company.website"
                        target="_blank"
                        class="text-body-2 text-primary text-truncate"
                        @click.stop
                      >
                        {{ company.website }}
                      </a>
                    </div>
                  </div>

                  <div class="mt-3 pt-2 border-top">
                    <div class="d-flex align-center text-body-2">
                      <span class="text-grey">
                        員工數: {{ company.employee_num }}
                      </span>
                      <v-spacer></v-spacer>
                      <v-btn
                        icon
                        small
                        class="mr-1"
                        color="#344767"
                        @click.stop="viewProfile(company)"
                      >
                        <v-icon size="18">ni-building</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="canNotifyCompanies"
                        icon
                        small
                        class="mr-1"
                        color="#17c1e8"
                        @click.stop="notifyCompanyEmployees(company)"
                      >
                        <v-icon size="18">mdi-bell</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="company.id !== 1 && !company.is_active"
                        icon
                        small
                        @click.stop="reactivateItem(company)"
                      >
                        <v-icon size="18">ni-button-play</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="
                          company.id !== companies[0].id && company.is_active
                        "
                        icon
                        small
                        @click.stop="deleteItem(company)"
                      >
                        <v-icon size="18">ni-button-pause</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-if="companies.length === 0 && !loading">
            <v-col cols="12" class="text-center">
              <p class="text-body">找不相關公司</p>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div ref="sentinel" class="d-flex justify-center py-4">
        <v-progress-circular
          v-if="loadingMore"
          indeterminate
          color="#cb0c9f"
          size="24"
        ></v-progress-circular>
      </div>
    </v-card>

    <!-- Company Profile Component -->
    <CompanyProfile
      v-if="showCompanyProfile"
      :company="selectedCompany"
      v-on:onClose="handleBack"
      @back="handleBack"
    />

    <!-- Progress Dialog -->
    <ProgressDialog :visible="showProgressDialog" :message="progressMessage" />

    <!-- Info Dialog -->
    <info-dialog
      :visible.sync="infoDialog.visible"
      :title="infoDialog.title"
      :message="infoDialog.message"
      :yes-button-text="infoDialog.yesButtonText"
      :yes-callback="infoDialog.yesCallback"
    />

    <!-- Confirm Dialog -->
    <confirm-dialog
      :visible.sync="confirmDialog.visible"
      :title="confirmDialog.title"
      :message="confirmDialog.message"
      :yes-button-text="confirmDialog.yesButtonText"
      :no-button-text="confirmDialog.noButtonText"
      :yes-callback="confirmDialog.yesCallback"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ProgressDialog from "@/components/Common/ProgressDialog.vue";
import InfoDialog from "@/components/Common/InfoDialog.vue";
import ConfirmDialog from "@/components/Common/ConfirmDialog.vue";
import CompanyProfile from "@/views/Pages/Companies/CompanyProfile.vue";
import CompanyBasicInfoWidget from "@/views/Pages/Companies/Widgets/ProfileWidgets/CompanyBasicInfoWidget.vue";
import CompanyContactInfoWidget from "@/views/Pages/Companies/Widgets/ProfileWidgets/CompanyContactInfoWidget.vue";
import CompanyFinancialInfoWidget from "@/views/Pages/Companies/Widgets/ProfileWidgets/CompanyFinancialInfoWidget.vue";
import httpClient from "@/utils/httpClient";
import { SCHEDULE_TYPE } from "@/constants";

export default {
  name: "paginated-tables",
  components: {
    ProgressDialog,
    InfoDialog,
    ConfirmDialog,
    CompanyProfile,
    CompanyBasicInfoWidget,
    CompanyContactInfoWidget,
    CompanyFinancialInfoWidget,
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 15,
      loadingMore: false,
      observer: null,
      dialog: false,
      companies: [],
      company_name: "",
      showAll: false,
      statusFilter: "active",
      statusOptions: [
        { text: "全部", value: "all" },
        { text: "啟用中", value: "active" },
        { text: "停用中", value: "disable" },
      ],
      searchDebounceTimer: null,
      loading: false,
      totalItems: 0,
      showProgressDialog: false,
      progressMessage: "Loading companies...",
      showCompanyProfile: false,
      selectedCompany: null,
      viewMode: "list",
      targetRefreshPage: 1,
      companyPageMap: {},
      infoDialog: {
        visible: false,
        title: "操作成功",
        message: "",
        yesButtonText: "確定",
        yesCallback: null,
      },
      confirmDialog: {
        visible: false,
        title: "確認",
        message: "",
        yesButtonText: "確定",
        noButtonText: "取消",
        yesCallback: null,
      },
      notifyingCompany: false,
      editedIndex: -1,
      activeTab: "tab-1",
      saving: false,
      editedItem: {
        company_name: "",
        taxid: "",
        capital_str: "",
        employee_num: "",
        website: "",
        owner_name: "",
        owner_mobile: "",
        owner_email: "",
        owner_identity: "",
        contact_address: "",
        contact_city: "",
        contact_region: "",
        contact_name: "",
        contact_mobile_country_code: "",
        contact_mobile: "",
        fixed_working_days: true,
        schedule_type: SCHEDULE_TYPE.GENERAL,
      },
      defaultItem: {
        company_name: "",
        taxid: "",
        capital_str: "",
        employee_num: "",
        website: "",
        owner_name: "",
        owner_mobile: "",
        owner_email: "",
        owner_identity: "",
        contact_address: "",
        contact_city: "",
        contact_region: "",
        contact_name: "",
        contact_mobile_country_code: "",
        contact_mobile: "",
        fixed_working_days: true,
        schedule_type: SCHEDULE_TYPE.GENERAL,
      },
      pagination: {
        currentPage: 1,
        pageSize: 20,
        totalItems: 0,
        totalPages: 1,
      },
      headers: [
        {
          text: "啟用",
          value: "is_active",
          sortable: false,
          class:
            "text-secondary font-weight-bolder opacity-7 black--text black--text",
        },
        {
          text: "公司名稱",
          sortable: false,
          value: "company_name",
          class:
            "text-secondary font-weight-bolder opacity-7 black--text black--text",
        },
        {
          text: "統一編號",
          value: "taxid",
          sortable: false,
          class:
            "text-secondary font-weight-bolder opacity-7 black--text black--text",
        },
        {
          text: "員工數",
          value: "employee_num",
          sortable: false,
          class:
            "text-secondary font-weight-bolder opacity-7 black--text black--text",
        },
        {
          text: "聯絡地址",
          value: "contact_address",
          sortable: false,
          class:
            "text-secondary font-weight-bolder opacity-7 black--text black--text",
        },
        {
          text: "網站",
          value: "website",
          sortable: false,
          class:
            "text-secondary font-weight-bolder opacity-7 black--text black--text",
        },
        {
          text: "操作",
          value: "actions",
          sortable: false,
          class:
            "text-secondary font-weight-bolder opacity-7 black--text black--text",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("user", ["userToken", "userRole"]),
    formTitle() {
      return this.editedIndex === -1 ? "新增公司" : "編輯公司";
    },
    canNotifyCompanies() {
      return ["superadmin", "consultant", "hr"].includes(this.userRole);
    },
  },
  async mounted() {
    if (this.$vuetify.breakpoint.mobile) {
      this.viewMode = "grid";
    }
    await this.fetchCompanies();
    this.initIntersectionObserver();
  },
  beforeDestroy() {
    // Clean up debounce timer
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    async fetchCompanies(append = false) {
      try {
        if (append) {
          this.loadingMore = true;
        } else {
          this.loading = true;
        }
        // Build query parameters
        let url = `/api/companies?page=${this.page}&limit=${this.itemsPerPage}`;

        // Add company_name search parameter if provided
        if (this.company_name && this.company_name.trim()) {
          url += `&company_name=${encodeURIComponent(
            this.company_name.trim()
          )}`;
        }

        // Apply status filter
        if (this.statusFilter === "active") {
          url += `&is_active=1`;
        } else if (this.statusFilter === "disable") {
          url += `&is_active=0`;
        }

        // Use axios to fetch companies; auth header is injected by interceptor
        const response = await this.$axios.get(url);

        if (append) {
          this.companies = [...this.companies, ...response.data.data];
        } else {
          this.companies = response.data.data;
          this.companyPageMap = {}; // Reset map on fresh load of first page (or filtered search)
        }

        // Populate companyPageMap
        const currentPage = response.data.pagination.currentPage;
        response.data.data.forEach((company) => {
          this.$set(this.companyPageMap, company.id, currentPage);
        });

        this.pagination = response.data.pagination;
        this.pageCount = this.pagination.totalPages;
        this.totalItems = this.pagination.totalItems;
      } catch (error) {
        console.error("Error fetching companies:", error);
        this.progressMessage = "Error loading data...";
        alert("Failed to fetch companies");
      } finally {
        this.loading = false;
        this.loadingMore = false;
      }
    },

    notifyCompanyEmployees(item) {
      this.editedIndex = this.companies.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.confirmDialog.title = "確認發送通知";
      this.confirmDialog.message = `你確定要對公司 "${item.company_name}" 的所有員工發送通知嗎？`;
      this.confirmDialog.yesButtonText = "確定";
      this.confirmDialog.noButtonText = "取消";
      this.confirmDialog.yesCallback = async () => {
        await this.notifyCompanyEmployeesConfirm();
        this.confirmDialog.yesCallback = null;
      };
      this.confirmDialog.visible = true;
    },

    async notifyCompanyEmployeesConfirm() {
      try {
        if (this.notifyingCompany) {
          return;
        }
        this.notifyingCompany = true;
        this.showProgressDialog = true;
        this.progressMessage = "正在發送通知給公司所有員工...";

        await httpClient.post(
          `/api/companies/${this.editedItem.id}/notify-employees`,
          {
            title: "公司通知",
            message: `公司 "${this.editedItem.company_name}" 有新的公告或設定更新，請開啟 APP 查看。`,
          }
        );

        this.showProgressDialog = false;

        this.infoDialog.title = "操作成功";
        this.infoDialog.message = `已向公司 "${this.editedItem.company_name}" 的所有員工發送通知。`;
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = null;
        this.infoDialog.visible = true;

        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      } catch (error) {
        console.error("Error notifying company employees:", error);
        this.showProgressDialog = false;

        const errorMsg =
          error.response?.data?.message || error.message || "發送通知失敗";
        this.infoDialog.title = "操作失敗";
        this.infoDialog.message = `發送通知失敗：${errorMsg}`;
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = null;
        this.infoDialog.visible = true;
      } finally {
        this.notifyingCompany = false;
      }
    },

    onSearchInput() {
      // Clear existing timer
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }

      // Set new timer for 500ms debounce
      this.searchDebounceTimer = setTimeout(() => {
        this.page = 1; // Reset to first page when searching
        this.fetchCompanies();
      }, 500);
    },

    initIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      };
      this.observer = new IntersectionObserver((entries) => {
        const target = entries[0];
        if (
          target.isIntersecting &&
          !this.loading &&
          !this.loadingMore &&
          this.page < this.pageCount
        ) {
          this.page += 1;
          this.fetchCompanies(true);
        }
      }, options);

      const target = this.$refs.sentinel;
      if (target) {
        this.observer.observe(target);
      }
    },

    onShowAllChange() {
      this.page = 1; // Reset to first page
      this.fetchCompanies();
    },

    onStatusChange() {
      this.page = 1; // Reset to first page
      this.fetchCompanies();
    },

    async onPageChange(newPage) {
      this.page = newPage;
      await this.fetchCompanies();
    },

    async onItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.page = 1;
      await this.fetchCompanies();
    },

    editItem(item) {
      this.editedIndex = this.companies.indexOf(item);
      this.editedItem = Object.assign(
        {},
        {
          company_name: item.company_name,
          taxid: item.taxid,
          capital_str: item.capital_str,
          employee_num: item.employee_num,
          website: item.website,
          owner_name: item.owner_name,
          owner_mobile: item.owner_mobile,
          owner_email: item.owner_email,
        }
      );
      this.dialog = true;
    },

    reactivateItem(item) {
      this.editedIndex = this.companies.indexOf(item);
      this.editedItem = Object.assign({}, item);

      // Show confirm dialog
      this.confirmDialog.title = "確認重新啟用";
      this.confirmDialog.message = `你確定要重新啟用公司 "${item.company_name}" 嗎？`;
      this.confirmDialog.yesButtonText = "確定";
      this.confirmDialog.noButtonText = "取消";
      this.confirmDialog.yesCallback = async () => {
        await this.reactivateItemConfirm();
        this.confirmDialog.yesCallback = null;
      };
      this.confirmDialog.visible = true;
    },

    async reactivateItemConfirm() {
      try {
        this.showProgressDialog = true;
        this.progressMessage = "正在重新啟用公司...";

        // Call reactivate API
        await httpClient.post(
          `/api/companies/${this.editedItem.id}/reactivate`
        );

        this.showProgressDialog = false;

        // Show success dialog
        this.infoDialog.title = "操作成功";
        this.infoDialog.message = `公司 "${this.editedItem.company_name}" 已成功重新啟用！`;
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = async () => {
          await this.fetchCompanies();
          this.infoDialog.yesCallback = null;
        };
        this.infoDialog.visible = true;

        // Reset edited item
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      } catch (error) {
        console.error("Error reactivating company:", error);
        this.showProgressDialog = false;

        const errorMsg =
          error.response?.data?.message || error.message || "重新啟用失敗";
        this.infoDialog.title = "操作失敗";
        this.infoDialog.message = `重新啟用公司失敗：${errorMsg}`;
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = null;
        this.infoDialog.visible = true;
      }
    },

    deleteItem(item) {
      this.editedIndex = this.companies.indexOf(item);
      this.editedItem = Object.assign({}, item);

      // Show confirm dialog
      this.confirmDialog.title = "確認停用";
      this.confirmDialog.message = `你確定要停用公司 "${item.company_name}" 嗎？`;
      this.confirmDialog.yesButtonText = "確定";
      this.confirmDialog.noButtonText = "取消";
      this.confirmDialog.yesCallback = async () => {
        await this.deleteItemConfirm();
        this.confirmDialog.yesCallback = null;
      };
      this.confirmDialog.visible = true;
    },

    async deleteItemConfirm() {
      try {
        this.showProgressDialog = true;
        this.progressMessage = "正在停用公司...";

        // Call delete API
        await httpClient.delete(`/api/companies/${this.editedItem.id}`);

        this.showProgressDialog = false;

        // Show success dialog
        this.infoDialog.title = "操作成功";
        this.infoDialog.message = `公司 "${this.editedItem.company_name}" 已成功停用！`;
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = async () => {
          await this.fetchCompanies();
          this.infoDialog.yesCallback = null;
        };
        this.infoDialog.visible = true;

        // Reset edited item
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      } catch (error) {
        console.error("Error deleting company:", error);
        this.showProgressDialog = false;

        const errorMsg =
          error.response?.data?.message || error.message || "停用失敗";
        this.infoDialog.title = "操作失敗";
        this.infoDialog.message = `停用公司失敗：${errorMsg}`;
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = null;
        this.infoDialog.visible = true;
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.activeTab = "tab-1";
      });
    },

    onWidgetSave(section, payload, done) {
      // Merge the payload into editedItem
      Object.assign(this.editedItem, payload);
      // Call done callback to indicate success
      if (done) done(true);
    },

    async save() {
      try {
        this.saving = true;
        if (this.editedIndex > -1) {
          // Update existing company
          const response = await httpClient.put(
            `/api/companies/${this.companies[this.editedIndex].id}`,
            this.buildCompanyPayload()
          );
          Object.assign(this.companies[this.editedIndex], response.data);
          alert("公司資料已更新");
        } else {
          // Create new company
          const response = await httpClient.post(
            "/api/companies",
            this.buildCompanyPayload()
          );
          const company_name = response.data.company_name;

          // Show success dialog
          this.infoDialog.title = "操作成功";
          this.infoDialog.message = `公司 "${company_name}" 已成功創建！`;
          this.infoDialog.yesButtonText = "確定";
          this.infoDialog.yesCallback = async () => {
            await this.$store.dispatch("company/fetchCompaniesIDS");
            await this.fetchCompanies();
            this.infoDialog.yesCallback = null;
          };
          this.infoDialog.visible = true;
        }
        this.close();
      } catch (error) {
        console.error("Error saving company:", error);
        const errorMsg =
          error.response?.data?.message || error.message || "儲存失敗";
        console.log(errorMsg);
        // show error dialog
        this.infoDialog.title = "操作失敗";
        this.infoDialog.message = `儲存失敗：${errorMsg}`;
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = null;
        this.infoDialog.visible = true;
      } finally {
        this.saving = false;
      }
    },

    buildCompanyPayload() {
      return {
        company_name: this.editedItem.company_name || "",
        taxid: this.editedItem.taxid || "",
        capital_str: this.editedItem.capital_str || "",
        employee_num: this.editedItem.employee_num || 0,
        website: this.editedItem.website || "",
        owner_name: this.editedItem.owner_name || "",
        owner_mobile_country_code:
          this.editedItem.owner_mobile_country_code || "",
        owner_mobile: this.editedItem.owner_mobile || "",
        owner_email: this.editedItem.owner_email || "",
        owner_identity: this.editedItem.owner_identity || "",
        owner_city: this.editedItem.contact_city || "",
        owner_region: this.editedItem.contact_region || "",
        owner_address: this.editedItem.contact_address || "",
        contact_name: this.editedItem.contact_name || "",
        contact_mobile_country_code:
          this.editedItem.contact_mobile_country_code || "",
        contact_mobile: this.editedItem.contact_mobile || "",
        contact_city: this.editedItem.contact_city || "",
        contact_region: this.editedItem.contact_region || "",
        contact_address: this.editedItem.contact_address || "",
        fixed_working_days:
          typeof this.editedItem.fixed_working_days === "boolean"
            ? this.editedItem.fixed_working_days
            : true,
        schedule_type: this.editedItem.schedule_type || SCHEDULE_TYPE.GENERAL,
      };
    },

    viewProfile(item) {
      if (this.companyPageMap[item.id]) {
        this.targetRefreshPage = this.companyPageMap[item.id];
      } else {
        this.targetRefreshPage = this.page;
      }

      // Instead of navigating, show the company profile component
      this.selectedCompany = item;
      this.$store.dispatch("company/selectCompany", item.id);
      this.$store.dispatch("company/selectCompany", item.id);
      this.showCompanyProfile = true;
    },

    handleBack() {
      this.showCompanyProfile = false;
      this.$nextTick(() => {
        this.scrollToCompany(
          this.selectedCompany ? this.selectedCompany.id : null
        );
      });
      // Always refresh the target page to get latest data
      this.refreshCurrentPage(this.targetRefreshPage);
    },

    async refreshCurrentPage(page = this.page) {
      try {
        this.loading = true;
        // Build query parameters for specific page
        let url = `/api/companies?page=${page}&limit=${this.itemsPerPage}`;

        // Add company_name search parameter if provided
        if (this.company_name && this.company_name.trim()) {
          url += `&company_name=${encodeURIComponent(
            this.company_name.trim()
          )}`;
        }

        // Apply status filter
        if (this.statusFilter === "active") {
          url += `&is_active=1`;
        } else if (this.statusFilter === "disable") {
          url += `&is_active=0`;
        }

        const response = await this.$axios.get(url);

        // Update companyPageMap for refreshed items
        const currentPage = response.data.pagination.currentPage;
        response.data.data.forEach((company) => {
          this.$set(this.companyPageMap, company.id, currentPage);
        });

        // Calculate the index range for the target page in the companies array
        const startIndex = (page - 1) * this.itemsPerPage;
        const endIndex = startIndex + response.data.data.length;

        // Ensure we don't go out of bounds (though splice handles it, typically we append if needed, but here we replace existing chunk)
        // If the array is shorter than startIndex (e.g. somehow reset), we might need to handle it, but typically infinite scroll keeps data.
        if (startIndex < this.companies.length) {
          this.companies.splice(
            startIndex,
            endIndex - startIndex,
            ...response.data.data
          );
        }

        // Update pagination info
        this.pagination = response.data.pagination;
        this.pageCount = this.pagination.totalPages;
        this.totalItems = this.pagination.totalItems;
      } catch (error) {
        console.error("Error refreshing page:", error);
        alert("Failed to refresh company data");
      } finally {
        this.loading = false;
      }
    },

    rowClass(item) {
      return `company-row-${item.id}`;
    },

    scrollToCompany(companyId) {
      if (!companyId) return;
      const element = document.querySelector(`.company-row-${companyId}`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
    async refreshCompanies() {
      this.progressMessage = "正在頁面更新中...";
      this.showProgressDialog = true;
      try {
        await this.$axios.post("/api/companies/recalculate-employee-counts");

        // Clear data and reset pagination
        this.companies = [];
        this.page = 1;
        this.companyPageMap = {};

        // Reload first page
        await this.fetchCompanies();
      } catch (error) {
        console.error("Failed to refresh companies:", error);
        this.infoDialog.title = "刷新失敗";
        this.infoDialog.message = "無法頁面更新，請稍後再試。";
        this.infoDialog.visible = true;
      } finally {
        this.showProgressDialog = false;
      }
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
};
</script>

<style scoped>
.table >>> thead th {
  white-space: nowrap;
  font-size: 1rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.025rem;
  color: #8392ab;
  opacity: 0.7;
  padding: 0.75rem 1.5rem;
  border-bottom: 0.0625rem solid #e9ecef;
}

.table >>> tbody tr:last-child td {
  border-bottom: 0;
}

.table >>> tbody td {
  padding: 0.75rem 1.5rem;
  border-bottom: 0.0625rem solid #e9ecef;
}

.table >>> tbody tr:hover {
  background: #f8f9fa;
}
</style>
